import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { useQueryBackgroundChecksRequest } from "../../../query/backgroundChecks/queries/useQueryBackgroundChecksRequest";
import { useQueryInsuranceCoverageMonitor } from "../../../query/insuranceCoverageMonitor/queries/useQueryInsuranceCoverageMonitor";
import { useQuerySharedFile } from "../../../query/sharedFile/query/useQuerySharedFile";
import { useQuerySignedDocument } from "../../../query/signedDocuments/query/useQuerySignedDocument";
import { getRequirementDefinitionName } from "../../RequirementDefinitions/utils";

export const usePayeeRequirementNames = (props: {
  requirementType: RequirementType;
  requirementDataSourceId: string;
}) => {
  const { requirementType, requirementDataSourceId } = props;

  const querySignedDocument = useQuerySignedDocument(requirementDataSourceId, {
    enabled: requirementType === RequirementType.Signature
  });

  const queryBackgroundCheck = useQueryBackgroundChecksRequest(
    requirementDataSourceId,
    {
      enabled: requirementType === RequirementType.BackgroundCheck
    }
  );

  const querySharedFile = useQuerySharedFile(requirementDataSourceId, {
    enabled: requirementType === RequirementType.SharedFile
  });

  const queryInsuranceCoverageMonitor = useQueryInsuranceCoverageMonitor(
    requirementDataSourceId,
    {
      enabled: requirementType === RequirementType.InsuranceCoverage
    }
  );

  const nameByDefinition = getRequirementDefinitionName({
    type: requirementType,
    contextType: querySharedFile.data?.contextType,
    policyType: (queryInsuranceCoverageMonitor.data as any)?.policyType
  });

  const namesMapByDataSource: Record<RequirementType, string | undefined> = {
    [RequirementType.Signature]: querySignedDocument.data?.title,
    [RequirementType.BackgroundCheck]:
      queryBackgroundCheck.data?.settings?.title,
    [RequirementType.SharedFile]: querySharedFile.data?.title,
    [RequirementType.IdentityVerification]: nameByDefinition,
    [RequirementType.InsuranceCoverage]: nameByDefinition,
    [RequirementType.Registration]: nameByDefinition,
    [RequirementType.TaxVerification]: nameByDefinition,
    [RequirementType.PayoutMethod]: nameByDefinition
  };

  const loaders: Record<RequirementType, boolean> = {
    [RequirementType.Signature]: querySignedDocument.isLoading,
    [RequirementType.BackgroundCheck]: queryBackgroundCheck.isLoading,
    [RequirementType.SharedFile]: querySharedFile.isLoading,
    [RequirementType.IdentityVerification]: false,
    [RequirementType.InsuranceCoverage]: false,
    [RequirementType.Registration]: false,
    [RequirementType.TaxVerification]: false,
    [RequirementType.PayoutMethod]: false
  };

  return {
    isLoading: loaders[requirementType],
    name: namesMapByDataSource[requirementType] || nameByDefinition,
    definitionName: nameByDefinition
  };
};
